import React, { Component } from "react";
import SearchComponent from "./SearchComponent";
import { Card } from "semantic-ui-react";
import { CardsContent } from "./CardsComponent";
import ReportDetail from "./ReportsDetailsComponent";
import { Services } from "../../Reports/Services";
import axios from "axios";
import Loader from "./../../../Global/Loader/index";


class MyReports extends Component {
  state = {
    loaderMap: false,
    CONTENT: "",
    inReportDetail: false,
    dataTable: [{}],
    results: 0,
    client: this.props.client ? this.props.client : '',
    User: this.props.user,
  };

  componentDidMount = () => {
    this.handleGetReports();
  };

  handleGetReports = () => {
    axios
      .get(`${Services.GET_REPORTS_ALL.path}reports/all/${this.state.User}`)
      .then((response) => {
        if (response.data.data) {
          this.setState({
            CONTENT: (
              <CardsContent
                handleIn={this.handleReportsDetail}
                cards={response.data.data}
              />
            ),
            data: this.props.data,
            inReportDetail: false,
            loaderMap: true,
          });
        }
      })
      .catch((error) => {
        console.warn("ERROR", error);
      });
  };

  handleReportsDetail = (item) => (evt) => {
    console.log("item", item);

    this.setState({
      CONTENT: (
        <ReportDetail
          handleBack={this.handleBack}
          item={item}
          table={this.state.dataTable}
          results={this.state.results}
          itemsByPage={this.props.itemsByPage}
          client={this.state.client}
        />
      ),
      inReportDetail: true,
    });
  };

  handleBack = (evt) => {
    this.handleGetReports();
  };

  handlerSearch = (filterResults) => {
    this.setState({
      CONTENT: (
        <CardsContent
          handleIn={this.handleReportsDetail}
          cards={filterResults}
        />
      ),
      inDetail: false,
    });
  };

  render() {
    let { CONTENT, inReportDetail, data, loaderMap } = this.state;
    return (
      <div>
        <Loader hidden={loaderMap}></Loader>

        {inReportDetail ? (
          ""
        ) : (
          <SearchComponent data={data} filter={this.handlerSearch} />
        )}
        <br />
        <Card.Group>{CONTENT}</Card.Group>
      </div>
    );
  }
}

export default MyReports;
